import { PageHeader, Spin, Tooltip } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
  TableItem,
  ButtonItem,
  dineroDisabledMask,
  HeaderActions,
} from "../../../Components/Items";
import {
  columnasBase,
  columnaMargenReal,
  descargarLibroPrecios,
} from "./plantillaPreciosExcel";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import IconListDetails from "../../../Icons/IconListDetails";

class ListasDePrecios extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    archivosExcel: [],
    data: [],
    archivoError: null,
    listaDePrecios: [],
    preciosEmpresa: [],
    agregarColumnas: [],
  }

  componentDidMount() {
    this.setState({ loading: true })
    axios
      .post(
        "insumos/selectListasDePrecios",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success === 2) {
          this.setState({
            listaDePrecios: res.data.listaDePrecios,
            preciosEmpresa: res.data.preciosEmpresa,
            agregarColumnas: res.data.preciosEmpresa.map((precio) => {
              return {
                title: `Precio ${precio.nombre}`,
                dataIndex: `precio_${precio._id}`,
                key: `precio_${precio._id}`,
                render: (text, record) => {
                  if (!text) return '-'
                  // El ultimo costo ya viene en la moneda del insumo y dividido
                  // entre el factor en las equivalencias, asi que se compara directo.
                  if (record.ultimoCostoCompra && text < record.ultimoCostoCompra) {
                    return (
                      <Tooltip title="Debajo del último costo de compra">
                        <span style={{ color: "red" }}>{dineroDisabledMask(text)}</span>
                      </Tooltip>
                    )
                  }
                  return dineroDisabledMask(text)
                },
                sorter: (a, b) => {
                  const valA = a[`precio_${precio._id}`] ?? 0;
                  const valB = b[`precio_${precio._id}`] ?? 0;

                  if (valA < valB) return -1;
                  if (valA > valB) return 1;
                  return 0;
                },
                buscar: `precio_${precio._id}`,
              };
            }),
          })
        } else {
          this.setState({ listaDePrecios: [] });
        }
      });
  }

  descargarListaDePrecios() {
    let datosDescargar = []
    datosDescargar = this.state.listaDePrecios.map((valueInsumo) => {

      let agregarPPrecios = {}

      if (valueInsumo.precios && valueInsumo.precios.length > 0) {
        valueInsumo.precios.forEach((valuePrecio) => {

          const precioEmpresa = this.state.preciosEmpresa.find((precio) => precio._id.toString() === valuePrecio.precioId.toString())

          if (!precioEmpresa) return

          agregarPPrecios = {
            ...agregarPPrecios,
            [`Precio ${precioEmpresa.nombre}`]: valuePrecio.precio,
            // El margen que ese precio deja hoy contra el ultimo costo de compra.
            ...columnaMargenReal(valueInsumo, precioEmpresa),
          }
        })
      }

      return {
        ...columnasBase(valueInsumo),
        ...agregarPPrecios,
      };
    });
    descargarLibroPrecios(
      [{ nombre: "Lista de Precios", filas: datosDescargar }],
      `Lista_de_Precios_${moment().format("YYYY-MM-DD")}`
    );
  }

  modificarPrecios() {
    this.props.history.push("/panel/modificarPrecios")
  }

  analizarDiferencias() {
    this.props.history.push("/panel/analizarDiferenciasPrecios")
  }

  fijarPorcentajes() {
    this.props.history.push("/panel/fijarPorcentajesPrecios")
  }

  reglasListasDePrecios() {
    this.props.history.push("/panel/reglasListasDePrecios")
  }

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        sorter: (a, b) => {
          if (a.clave < b.clave) {
            return -1;
          }
          if (a.clave > b.clave) {
            return 1;
          }
          return 0;
        },
        buscar: "clave",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
        with: "20%",
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        sorter: (a, b) => {
          if (a.unidad < b.unidad) {
            return -1;
          }
          if (a.unidad > b.unidad) {
            return 1;
          }
          return 0;
        },
        buscar: "unidad",
        with: "10%",
      },
      {
        title: "Último Costo",
        dataIndex: "ultimoCostoCompra",
        key: "ultimoCostoCompra",
        render: (text) => {
          if (text) return dineroDisabledMask(text)
          return '-'
        },
        sorter: (a, b) => {
          const valA = a.ultimoCostoCompra ?? 0;
          const valB = b.ultimoCostoCompra ?? 0;

          if (valA < valB) return -1;
          if (valA > valB) return 1;
          return 0;
        },
        buscar: "ultimoCostoCompra",
      },
      ...this.state.agregarColumnas,
    ];
    return (
      <>
        <PageHeader
          title={(
            <span>
              <IconListDetails />
              Listas de Precios
              &nbsp;
            </span>
          )}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
           <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <HeaderActions>
            <ButtonItem onClick={() => this.modificarPrecios()} type="primary">Modificar</ButtonItem>
            <ButtonItem onClick={() => this.fijarPorcentajes()} lila type="primary" >Fijar porcentajes</ButtonItem>
            <ButtonItem onClick={() => this.analizarDiferencias()} siena type="primary">Analizar diferencias</ButtonItem>
            <ButtonItem onClick={() => this.reglasListasDePrecios()} cyan type="primary">Reglas</ButtonItem>
            </HeaderActions>
            <ButtonItem onClick={() => this.descargarListaDePrecios()} icon={<DownloadOutlined />} type="primary"
            olivo className="botonAgregar"
            >Descargar</ButtonItem>
            </div>
          ]}
        />
          <Spin spinning={this.state.loading}>
            <TableItem size='small' dataSource={this.state.listaDePrecios} columns={columns} />
          </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ListasDePrecios);
